// extracted by mini-css-extract-plugin
export default {"box":"reset-password_box__YnkUb","link":"reset-password_link__95ttw"};